/* eslint-disable react/jsx-pascal-case */
import { SecureGlobalStyle } from "config/global.style";
import { ThemeProviderWrapper } from "context/themeContext";
import MainLayout from "./components/layouts/MainLayout"; 

export default function App() {
  return (
    <ThemeProviderWrapper>
      <SecureGlobalStyle />
      <MainLayout />
    </ThemeProviderWrapper>
  );
}
